'use client';

import { c as _c } from "react/compiler-runtime";
type SubscriptionStatusProviderProps = {
  children: React.ReactNode;
};
export function SubscriptionStatusProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}